<section class="breadcrumb-section">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="breadcrumb-title">
                    <h1>Institute Anti Ragging Committee</h1>
                </div>
            </div>
        </div>			
    </div>
</section>      
<section  class="section-lg std-scholarship">
    <div class="container">
        <div class="table-responsive" > 
            <table class="table table-bordered text-center tbl_custom">
                <thead>
                    <tr>
                        <th>Sr. No.</th>
                        <th>Name</th>
                        <th>Designation</th>
                      </tr>
                </thead>
                <tbody>
                    
                    <tr>
                        <td>1</td>
                        <td>Dr. Jasvinder Kaur</td>
                        <td>Chairperson</td>
                    </tr>
                    <tr>
                        <td>2</td>
                        <td>API Prashant Sabade WAPI Shradha Bhopale</td>
                        <td>Civil and Police administration</td>
                    </tr>
                    <tr>
                        <td>3</td>
                        <td>Mr. Anup Ghumare</td>
                        <td>Local Media Member</td>
                    </tr>
                    <tr>
                        <td>4</td>
                        <td>Mr. Ashish Dubey</td>
                        <td>Member of NGO</td>
                    </tr>
                    <tr>
                        <td>5</td>
                        <td>Mr. Pankaj Pethe</td>
                        <td>Faculty Member Representative</td>
                    </tr>
                    <tr>
                        <td>6</td>
                        <td>Ms. Kalyani Dubey</td>
                        <td>Faculty Member Representative</td>
                    </tr>
                    <tr>
                        <td>7</td>
                        <td>Mr Ujjwal Sharma</td>
                        <td>Student Member</td>
                    </tr>
                    <tr>
                        <td>8</td>
                        <td>Ms Sugandh Khemani</td>
                        <td>Student Member</td>
                    </tr>
                    <tr>
                        <td>9</td>
                        <td>Mr. Ashish Tiwari</td>
                        <td>Parents Representative</td>
                    </tr>
                    <tr>
                        <td>10</td>
                        <td>Mr. Yusuf Khan</td>
                        <td>Non Teaching Representative</td>
                    </tr>
                </tbody>
            </table>
      
        </div>
    </div>
</section>
